import React from 'react';
import PropertyCard from './PropertyCard';
import Pagination from '../../../components/ui/Pagination';

const PropertyGrid = ({
  properties,
  loading,
  favoritePropertyIds, // Changed from favoriteProperties
  currentPage = 1,
  totalPages = 1,
  totalResults = 0,
  onPageChange
}) => {
  const SkeletonCard = () => (
    <div className="bg-card border border-border rounded-lg overflow-hidden shadow-sm animate-pulse">
      <div className="h-48 bg-muted" />
      <div className="p-4 space-y-3">
        <div className="h-6 bg-muted rounded w-3/4" />
        <div className="h-4 bg-muted rounded w-full" />
        <div className="h-4 bg-muted rounded w-2/3" />
        <div className="flex justify-between">
          <div className="h-4 bg-muted rounded w-1/3" />
          <div className="h-4 bg-muted rounded w-1/4" />
        </div>
      </div>
    </div>
  );

  if (loading && properties?.length === 0) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {Array.from({ length: 12 })?.map((_, index) => (
          <SkeletonCard key={index} />
        ))}
      </div>
    );
  }

  if (properties?.length === 0 && !loading) {
    return (
      <div className="text-center py-12">
        <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-muted-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
          </svg>
        </div>
        <h3 className="text-lg font-medium text-foreground mb-2">No properties found</h3>
        <p className="text-muted-foreground mb-4">
          Try adjusting your search criteria or browse all available properties.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Property Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {properties?.map((property) => (
          <PropertyCard
            key={property?.id}
            property={property}
            isFavorite={favoritePropertyIds?.includes(property?.id)} // Updated to use favoritePropertyIds
          />
        ))}
      </div>
      {/* Pagination Controls */}
      {totalPages > 1 && !loading && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalResults={totalResults}
          resultsPerPage={12}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
};

export default PropertyGrid;
